<script setup lang="ts">
import { RouterView } from 'vue-router';
import 'vfonts/Inter.css';
import { watch } from 'vue';

import { useTheme } from '@/composables/use-theme';

// Theme management
const { currentTheme, themeOverrides, isDarkMode, themeColors } = useTheme();

// Apply dark class to body and set CSS custom properties
watch(
  [isDarkMode, themeColors],
  ([newDarkMode, colors]) => {
    if (newDarkMode) {
      document.body.classList.add('dark');
    } else {
      document.body.classList.remove('dark');
    }

    // Set global CSS custom properties for theme colors
    const root = document.documentElement;
    root.style.setProperty('--highlight-bg', colors.highlight);
    root.style.setProperty('--frozen-column-bg', colors.frozenColumn);
    root.style.setProperty('--table-row-bg', colors.tableRowHover);
    root.style.setProperty('--table-row-hover-bg', colors.tableRowHover);
    root.style.setProperty('--theme-background', colors.background);
    root.style.setProperty('--theme-surface', colors.surface);
    root.style.setProperty('--theme-primary', colors.primary);
    root.style.setProperty('--theme-text', colors.text);
    root.style.setProperty('--theme-border', colors.border);

    // Apply background to body for consistent scrolling
    document.body.style.backgroundColor = colors.background;
  },
  { immediate: true }
);
</script>

<template>
  <n-config-provider :theme="currentTheme" :theme-overrides="themeOverrides">
    <n-dialog-provider>
      <n-message-provider>
        <n-loading-bar-provider>
          <n-notification-provider>
            <RouterView :key="$route.fullPath" />
          </n-notification-provider>
        </n-loading-bar-provider>
      </n-message-provider>
    </n-dialog-provider>
  </n-config-provider>
</template>

<style>
body {
  margin: 0;
  -webkit-font-smoothing: antialiased;
  transition: background-color 0.3s ease;
  font-feature-settings: 'cv02', 'cv03', 'cv04', 'cv11';
  min-height: 100dvh;
}

body.dark {
  background-color: #1a1a1a;
  color: #ffffff;
}

* {
  --n-scrollbar-width: 10px;
  --n-scrollbar-height: 10px;
}

.n-page-header {
  flex-wrap: wrap;
  gap: 0.5rem;
}

/* hide subtitle on mobile */
@media (max-width: 768px) {
  .n-page-header__subtitle {
    display: none;
  }
}
</style>
